import React from 'react';
import Link from '../Link';
import PropTypes from 'prop-types';

const Card = props => {
  const [isEn, setIsEn] = React.useState(false);

  React.useEffect(() => {
    setIsEn(typeof window !== 'undefined' && window.$isEn);
  }, []);

  const renderCardContent = () => {
    return (
      <Link className='fui-card-action' to={props.link} target={props.target}>
        {props.image ? (
          <div className='fui-card-image'>
            <img src={props.image} srcSet={props.retinaImage || props.image} alt={props.alt} />
          </div>
        ) : (
          ''
        )}
        <div className='fui-card-caption'>
          <div className='fui-card-content'>
            {!props.public_at ? '' : <div className='fui-card-date'>{props.public_at}</div>}
            {!props.meta ? '' : <div className='fui-card-meta'>{props.meta}</div>}
            <h6 className='name'>{props.title}</h6>
            {!props.description ? (
              ''
            ) : (
              <p className='fui-card-description' dangerouslySetInnerHTML={{ __html: props.description }}></p>
            )}
          </div>
        </div>
      </Link>
    );
  };

  return <div className={`fui-card ${props.className ? props.className : ''}`}>{renderCardContent()}</div>;
};

Card.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string,
  retinaImage: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  target: PropTypes.string,
  meta: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }),
};

export default Card;
